import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { paramCheck, requiredParamsCheck } from '../../utils';

export interface GetBLEDeviceCharacteristicsOption
  extends Partial<GeneralInvokeOption> {
  deviceId: string;
  serviceId: string;
  invalidParamObj?: '';
}

// 获取蓝牙低功耗设备某个服务中所有特征 (characteristic)
export function getBLEDeviceCharacteristics(
  option: GetBLEDeviceCharacteristicsOption
) {
  if (
    !requiredParamsCheck(
      { deviceId: option.deviceId, serviceId: option.serviceId },
      option,
      APINames.Native.GET_BLE_DEVICE_CHARACTERISTICS
    )
  ) {
    return option.invalidParamObj;
  }
  if (
    paramCheck(APINames.Native.GET_BLE_DEVICE_CHARACTERISTICS, option, {
      deviceId: '',
      serviceId: ''
    })
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.GET_BLE_DEVICE_CHARACTERISTICS,
      option
    );
  }
  return option.invalidParamObj;
}
